export const homeRoutes = {
  de: 'standortsuche',
  fr: 'recherche-de-site',
  it: 'ricerca-ubicazioni',
  en: 'location-search',
};
